module.exports = {
  'about': 'Сайт ҫинчен',
  'for_helpers': 'Пулӑшуçă валли',
  'menu': 'Менӳ',
  'history': 'Истори',
  'search_word': 'Сăмаха çырăр...',
  'n_i_ashmarin': 'Н.И. Ашмарин',
  'chuvash_dictionary': 'Чӑваш сӑмахӗсен кӗнеки',
  'articles_on_site': 'Сайтри статья шучӗ',
  'last_added_articles': 'Хальтерех кӗртнӗ статьясем',
  'haval_org': '"Хавал" чăваш халăх пĕрлешĕвĕ',
  'more_text': 'Туллин...'
}


// WEBPACK FOOTER //
// ./src/lang/cv/messages.js